import { render, staticRenderFns } from "./laboratory.vue?vue&type=template&id=0bebd6e9&"
import script from "./laboratory.vue?vue&type=script&lang=js&"
export * from "./laboratory.vue?vue&type=script&lang=js&"
import style0 from "./laboratory.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports